import { Modal } from "antd";
import { FC } from "react";

import { useLoc } from "@app/shared/lib/hooks";

import { useUIAppState } from "../../UIAppStateProvider";
import { StudentProfileForm } from "../StudentProfileForm/StudentProfileForm";

export const StudentProfileBlocker: FC = () => {
  const loc = useLoc();
  const UIAppState = useUIAppState();

  return (
    <Modal
      open
      closable={false}
      closeIcon={null}
      title={loc.word("User profile")}
      footer={null}
      width={600}
      destroyOnClose
      className="p-0"
    >
      <StudentProfileForm
        viewMode="required"
        onSave={() => UIAppState.setIsProfileDrawerVisible(false)}
      />
    </Modal>
  );
};
